import { RouterOutlet } from '@angular/router';
import { FooterComponent } from './core/footer/footer.component';
import { HeaderViewComponent } from './core/header-view/header-view.component';
import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [HeaderViewComponent, FooterComponent, RouterOutlet],
  providers: [],
})
export class AppComponent {
  title = 'Roadside';
}
